import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';

// import App from './containers/App';
import ErrorBoundary from './ErrorBoundary';
import CssBaseline from '@material-ui/core/CssBaseline';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider'; // https://reacttraining.com/react-router/web/guides/dealing-with-update-blocking
// import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { initializeHybridDataDogRUM } from 'utils/customRUM';

import VERSION from 'VERSION.js';
import './index.css';

import LoadingOverlay from './components/LoadingScreen/LoadingOverlay';

const App = React.lazy(() => import('./containers/App'));

let customRumInstance = null;

if (process.env.REACT_APP_DD_ENABLED === 'true') {
    // Move me to my own file when you see me. Or ignore me, idc
    datadogRum.init({
        applicationId: process.env.REACT_APP_DD_APP_ID,
        clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
        site: process.env.REACT_APP_DD_SITE,
        service: process.env.REACT_APP_DD_SERVICE,
        env: process.env.REACT_APP_ENV,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        defaultPrivacyLevel: 'mask-user-input',
        plugins: [reactPlugin({ router: false })], // router only works with certain version of react-router-dom
        allowedTracingUrls: [process.env.REACT_APP_API_URL]
    });
} else if (process.env.REACT_APP_CUSTOM_RUM_ENABLED === 'true') {
    const hybridRumOptions = {
        monitoringApiKey: process.env.REACT_APP_RUM_API_KEY,
        tempoEndpoint: process.env.REACT_APP_TEMPO_ENDPOINT,
        lokiEndpoint: process.env.REACT_APP_LOKI_ENDPOINT
    };

    try {
        customRumInstance = initializeHybridDataDogRUM(VERSION, hybridRumOptions);

        if (customRumInstance) {
            window.customRumInstance = customRumInstance;
        }
    } catch (error) {
        console.error('❌ Failed to initialize custom RUM:', error);
    }
}

const FirebaseAdmin = require('firebase/firebaseAdmin.js');
const Analytics = require('utils/analytics.js');

const startApp = () => {
    // init firebase services
    ReactDOM.render(
        <Router>
            <div id="indexjs" style={{ height: '100%' }}>
                <CssBaseline />
                <ErrorBoundary>
                    <Route
                        render={props => (
                            <>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <Suspense fallback={<></>}>
                                        <App />
                                    </Suspense>
                                </MuiPickersUtilsProvider>
                                <LoadingOverlay />
                            </>
                        )}
                    />
                </ErrorBoundary>
            </div>
        </Router>,
        document.getElementById('root')
    );
};

const app = {
    // Application Constructor
    init: function() {
        if (window.hasOwnProperty('cordova')) {
            document.addEventListener('deviceready', app.capacitorReady);
        } else {
            document.addEventListener('DOMContentLoaded', app.webReady);
        }
    },
    capacitorReady: function() {
        console.log('Capacitor version.');
        // @deprecated IN 2.17.0 PLEASE REMOVE ON NEXT RELEASE
        if (window.wkWebView) {
            // solution for iOS app cookies not working on first launch. the url here must match the api url exactly
            window.wkWebView.injectCookie(`${process.env.REACT_APP_COOKIE_URL}/api`);
        }
        Analytics.initializeAnalytics();
        FirebaseAdmin.init(); // still need to initialize firebase even though its done natively
        startApp(); // LETS GO!
    },
    webReady: function() {
        console.log('Web version.');
        FirebaseAdmin.init();
        Analytics.initializeAnalytics();
        startApp();
    }
};

window.addEventListener('beforeunload', () => {
    if (customRumInstance && customRumInstance.destroy) {
        customRumInstance.destroy();
    }
});

app.init();
// registerServiceWorker();
unregister();
